import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusFormatter',
  standalone: true
})
export class StatusFormatterPipe implements PipeTransform {

  private statusMap: Record<string, string> = {
    in_progress: 'In Progress',
    ready_to_start: 'Ready to Start',
    completed: 'Completed',
    overtime: 'Overtime',
    out_of_time: 'Out of Time',
    submitted: 'Submitted',
    scored: 'Completed',
    too_early_to_start: 'Too Early to Start',
    too_late_to_start: 'Too Late to Start',
  };

  transform(value: string): string {
    return this.statusMap[value] || this.autoFormat(value);
  }

  private autoFormat(value: string): string {
    if(value != undefined)
      return value
        .replace(/_/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase());
    else
      return value
  }
}
